module.exports = __webpack_public_path__ + "static/fipcneutralhelloworldmain-ebb4aab510be1248de8fabde8806dfd8.jpeg";